<template>
  <div>
    <div class="clearfix"></div>
    <div class="pager">
      <div class="form-row align-items-center">

        <button type="button" class="btn btn-sm btn-primary mx-3" @click="_jumpToPage(-1)"  v-if="this.currentPage > 1">
          <i class="fa fa-angle-left"></i> 
          上一页
        </button>
        可以使用&lt;- 和 -&gt;翻页

        <div class="current mx-3" >
          <div class="page-size">
            <select title="每页个数" class="form-control input-sm page-size-selector" :value="this.currentSize" @change="_choosePageSize">
              <option value="20">20</option> 
              <option value="30">30</option> 
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <span class="page-number mr-2">
            第{{ this.currentPage }}页
          </span>
          <span class="mr-2" v-if='this.count && this.count > 0'>共{{ this.count }}个 </span>
        </div>
        <button  v-if="(items || []).length > 0" class="next btn btn-primary btn-sm" @click="_jumpToPage(1)">
          下一页
          <i class="fa fa-angle-right"></i> 
        </button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
// 页面跳转
function _jumpToPage (pageDelta) {
  if (!this.allowedToJump()) {
    return
  }

  // 如果跳转下一页，且当前页面没有数据，则不要下一页了
  if (this.items.length === 0 && pageDelta > 0) {
    return
  }

  let newPage = parseInt(this.currentPage) + pageDelta
  // 错误的页数， 不导航
  if (newPage <= 0) {
    return
  }
  this.updateQuery({page: newPage})
}

// 按键的导航
function _choosePageSize (event) {
  let target = event.target
  let size = target.options[target.selectedIndex].value
  if (size < 0 || size > 100) { return }
  // 修改url, 选择页面的时候将page置1
  this.updateQuery({page: 1, size: size})
}

function allowedToJump () {
  // 如果focus在input textarea 禁止跳转
  const name = document.activeElement.nodeName
  if (name === 'INPUT' || name === 'TEXTAREA') {
    return false
  }

  // 没有modal， 可以直接跳转
  if (!document.querySelector('.modal')) {
    return true
  }

  // 有modal，且隐藏状态，可以跳转
  if (document.querySelector('.modal[style*="display: none"], .modal[style*="display: none"]')) {
    return true
  }
  return false
}

// function initSearch () {
//   let page = this.$route.query.page || this.page
//   let size = this.$route.query.size || this.size
// }

function updateQuery (object) {
  let query = Object.assign({}, this.$route.query)

  // remove query
  for (let key in object) {
    let value = object[key]
    if (value === '' || value === 'all') {
      delete query[key]
    } else {
      query[key] = value
    }
  }

  this.$router.push({query: query})
}

export default {
  name: 'pager',
  props: ['items', 'count'],
  data () {
    return {
      size: 20,
      page: 1
    }
  },
  methods: {
    _jumpToPage,
    _choosePageSize,
    allowedToJump,
    updateQuery
  },
  created () {
    //  左右方向键导航
    document.onkeyup = (e) => {
      if (e.keyCode === 37) {
        this._jumpToPage(-1)
      } else if (e.keyCode === 39) {
        this._jumpToPage(1)
      }
    }
  },
  computed: {
    currentPage: function () {
      return this.$route.query.page || 1
    },
    currentSize: function () {
      return this.$route.query.size || 20
    }
  }
}
</script>

<style lang="scss" scoped>
  .pager {
    float: right;
    margin: 0px 10px;

    .previous, .next, .current, .page-size, .page-number {
      display: inline-block;
    }
  }
</style>